import * as React from "react";
import { NotificationsContainer } from "./Notifications.styled";
import { Notification } from "./Notification";
import { observer } from "mobx-react";
import { useStores } from "../../../stores";
import { AnimatePresence } from "framer-motion";

interface NotificationsProps {}

export const Notifications = observer(({}: NotificationsProps) => {
	const { notificationsStore } = useStores();

	if (notificationsStore.list.length === 0) {
		return null;
	}

	return (
		<NotificationsContainer>
			<AnimatePresence mode="popLayout">
				{notificationsStore.list.map((notificationStore) => {
					return <Notification key={notificationStore.id} notificationStore={notificationStore} />;
				})}
			</AnimatePresence>
		</NotificationsContainer>
	);
});
